export default {"src":"/_next/static/media/stressMotivation.9a6c380e.svg","height":593,"width":1047,"blurWidth":0,"blurHeight":0};